export default __webpack_public_path__ + "static/media/person-group-green-icon-main.ef8688df.svg";